import { Platform } from "react-native";

type UpgradeRequiredHandler = () => void;

let handler: UpgradeRequiredHandler | null = null;
let pending = false;

/**
 * Register the callback that shows the blocking update screen.
 * A 426 that arrived before registration is delivered immediately.
 */
export function setUpgradeRequiredHandler(
    next: UpgradeRequiredHandler | null,
): void {
    handler = next;
    if (next && pending) {
        pending = false;
        next();
    }
}

/** Ask the app to show the blocking update screen. Web is ignored. */
export function notifyUpgradeRequired(): void {
    if (Platform.OS === "web") {
        return;
    }
    if (!handler) {
        pending = true;
        return;
    }
    handler();
}
